module.exports = __webpack_public_path__ + "img/logo4.6ef8bacf.png";